<template>
  <div>
    <QuestionList
      :title="title"
      :items="listQuestions"
      :search="search"
      :pagination="pagination"
      :dialogs="dialogs"
      :suffix="suffix"
      :replaceRoute="replaceRoute"
      @loadQuestions="loadQuestions"
      @deleteConfirm="deleteConfirm"
      @addDialogActivate="addDialogActivate"
      ref="questionList"
    />
  </div>
</template>

<script>
import QuestionList from '@/components/questions/QuestionList'
import ThematicQuestionService from '@/services/ThematicQuestionService'
import ObjectUtils from '@/utils/ObjectUtils'

export default {
  components: {QuestionList},
  data: () => ({
    title: 'Вопросы тематики',
    suffix: 'Thematic',
    listQuestions: [],
    pagination: {
      currentPage: 1,
      totalPages: 1
    },
    search: {
      category: [],
      number: null
    },
    forceReload: false,
    replaceRoute: false,
    dialogs: {
      editForm: {
        status: false,
        itemIndex: -1,
        editedItem: {}
      },
      delete: {
        status: false,
        itemIndex: -1
      },
      error: {
        status: false,
        errorDialogList: []
      },
      defaultItem: ThematicQuestionService.getDefaultItem()
    },
    thematicQuestionService: undefined
  }),
  methods: {
    addDialogActivate () {
      this.dialogs.editForm.status = true
    },
    init () {
      this.pagination.currentPage = this.$route.query.page ? Number.parseInt(this.$route.query.page) : 1
      this.initSearch()
      this.loadQuestions()
    },
    initSearch () {
      this.search.category = this.$route.query.category ? this.$route.query.category.split(',').map(string => Number.parseInt(string)) : []
      this.search.number = this.$route.query.number ? this.$route.query.number : null
    },
    loadQuestions () {
      let query = ObjectUtils.jsonCopy(this.$route.query)
      if (query.category) {
        query.category = query.category.split(',')
      }
      query.show_answers = true
      query.limit = 50
      if (this.forceReload || !this.$store.getters.isLoading) {
        this.thematicQuestionService.getList((data) => {
          this.pagination.totalPages = data.totalPages
          this.listQuestions = data.list
          if (this.pagination.currentPage > this.pagination.totalPages) {
            this.forceReload = true
            this.replaceRoute = true
            this.pagination.currentPage = this.pagination.totalPages
          } else {
            this.forceReload = false
            this.replaceRoute = false
            this.listQuestions = data.list
          }
        }, query)
      }
    },
    deleteConfirm () {
      let id = this.listQuestions[this.dialogs.delete.itemIndex].id
      this.thematicQuestionService.deleteItem(id, () => {
        this.forceReload = true
        this.loadQuestions()
        this.dialogs.delete.status = false
        this.dialogs.delete.itemIndex = -1
      })
    }
  },
  created () {
    this.thematicQuestionService = new ThematicQuestionService(this.$store)
    this.dialogs.editForm.editedItem = this.dialogs.defaultItem
    this.init()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/thematic/Index.vue